import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { AdminTitle, AInput, ATextarea } from "./AdminUi";

const FIELDS = [["hero_headline", "Hero headline", 1], ["hero_text", "Hero supporting text", 4], ["tagline", "Tagline", 1], ["promise_statement", "Promise statement", 3], ["about_text", "About introduction", 4], ["closing_message", "Closing message", 2]];

export default function AdminHomepage() {
  const [f, setF] = useState(null);
  useEffect(() => {
    api.get("/admin/homepage").then(({ data }) => setF(data));
  }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      const { key, ...payload } = f;
      await api.put("/admin/homepage", payload);
      toast.success("Homepage updated");
    } catch (err) {
      toast.error(formatError(err));
    }
  };
  if (!f) return <p role="status">Loading…</p>;
  return (
    <form onSubmit={save} className="max-w-3xl space-y-5" data-testid="admin-homepage-form">
      <AdminTitle title="Homepage content">Edit the main messages on the homepage. Changes appear immediately.</AdminTitle>
      {FIELDS.map(([k, label, rows]) => rows === 1
        ? <AInput key={k} id={`home-${k}`} label={label} value={f[k]} onChange={(v) => setF((s) => ({ ...s, [k]: v }))} required />
        : <ATextarea key={k} id={`home-${k}`} label={label} rows={rows} value={f[k]} onChange={(v) => setF((s) => ({ ...s, [k]: v }))} />)}
      <button type="submit" className="btn-primary" data-testid="homepage-save-button">Save homepage</button>
    </form>
  );
}
